var map = {
	"./book.jpg": 104,
	"./buch.png": 37,
	"./illu_habermas_1.jpg": 105,
	"./illu_habermas_1_mobile.jpg": 106,
	"./illu_habermas_2.jpg": 107,
	"./illu_habermas_2_mobile.jpg": 108,
	"./portrait_habermas.jpg": 38,
	"./readme.md": 109,
	"./vignetten-06.jpg": 110,
	"./vignetten_1.jpg": 111,
	"./vignetten_2.jpg": 112,
	"./vignetten_3.jpg": 113,
	"./vignetten_4.jpg": 114,
	"./vignetten_5.jpg": 115,
	"./vignetten_6.jpg": 116,
	"./vignetten_7.jpg": 117,
	"./vignetten_8.jpg": 118
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 103;